import { z } from 'zod'
import { normalizePhone } from '../utils/phone'

export const LoginSchema = z.object({
  phone: z
    .string()
    .min(10)
    .transform((v) => normalizePhone(v)),
  password: z.string().min(6),
})

export type LoginInput = z.input<typeof LoginSchema>
export type LoginDto = z.output<typeof LoginSchema>
